import * as yup from 'yup';

export const schemaSoracom = yup.object().shape({
  authKey: yup.string().nullable().required('SORACOMの authkey を入力してください'),
  authKeyId: yup.string().nullable().required('SORACOMの authkeyId を入力してください'),
});
